// extracted by mini-css-extract-plugin
export default {"box":"siteholder_box__ot20W","black":"siteholder_black__tSe6k","white":"siteholder_white__2dpqW","img":"siteholder_img__7rbhP","zoomin":"siteholder_zoomin__iF3sk"};